import flow from 'lodash/flow';
import { withMedia } from 'react-media-query-hoc';
import { withMediaQueryProvider } from '@domain-group/fe-allhomes-library';
import globalObserver from '@domain-group/fe-co-allhomes-global-observer';
import quickLinksFetcher from './quick-links-fetcher';
var outerLevel = [globalObserver, withMediaQueryProvider];
var additional = [quickLinksFetcher, withMedia];
var allhomesFooterWrapper = flow(...additional, ...outerLevel);
export default allhomesFooterWrapper;